import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCamera2"><Path d="M2.50001 20.5L2.5 5.5H8.53513C9.22675 4.3044 10.5194 3.5 12 3.5C13.4806 3.5 14.7733 4.3044 15.4649 5.5H21.5L21.5 20.5H2.50001Z" stroke="currentColor"/><Path d="M15.5 12.5C15.5 14.433 13.933 16 12 16C10.067 16 8.50001 14.433 8.50001 12.5C8.50001 10.567 10.067 9 12 9C13.933 9 15.5 10.567 15.5 12.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCamera2;
